import joi from 'joi';
import endpoints from 'constants/endpoints';
import { percentageMask } from 'constants/masks';
import formErrors from 'constants/formErrors';
import { percentageRegex } from 'constants/regex';
import { timeZones } from 'constants/timeZones';
import { InputsEnum, TextInputTypes } from 'types/dynamicInputs';

export default {
  ubication: {
    value: {
      name: '',
      address: {
        lineOne: '',
        lineTwo: '',
        city: '',
        state: '',
        postalCode: ''
      },
      coordinates: undefined
    },
    label: 'Ubication',
    input: InputsEnum.GOOGLE_MAPS_AUTOCOMPLETE,
    joi: joi
      .object({
        name: joi.string().required().messages({
          'string.empty': formErrors.REQUIRED
        }),
        address: joi
          .object({
            lineOne: joi.string().required().messages({
              'string.empty': formErrors.REQUIRED
            }),
            lineTwo: joi.string().optional().allow(''),
            city: joi.string().required().messages({
              'string.empty': formErrors.REQUIRED
            }),
            state: joi.string().required().messages({
              'string.empty': formErrors.REQUIRED
            }),
            postalCode: joi.string().required().messages({
              'string.empty': formErrors.REQUIRED
            })
          })
          .required(),
        coordinates: joi
          .object({
            lat: joi.number().required(),
            lng: joi.number().required()
          })
          .optional()
      })
      .required()
      .messages({
        'object.base': formErrors.REQUIRED
      })
  },
  venueName: {
    value: '',
    label: 'Name',
    limit: 150,
    input: InputsEnum.INPUT,
    type: TextInputTypes.TEXT,
    joi: joi.string().required().messages({
      'string.empty': formErrors.REQUIRED
    })
  },

  isActive: {
    value: false,
    label: 'Is active',
    input: InputsEnum.CHECK,
    joi: joi.boolean().optional()
  },

  accountId: {
    value: '',
    label: 'Account',
    input: InputsEnum.AUTOCOMPLETE,
    endpoint: endpoints.SEARCH_ACCOUNT,
    type: TextInputTypes.TEXT,
    joi: joi.string().required().messages({
      'string.empty': formErrors.REQUIRED
    })
  },

  timezone: {
    value: '',
    options: [...timeZones.map((item: any) => ({ label: item, value: item }))],
    label: 'Timezone',
    input: InputsEnum.SELECT,
    joi: joi.string().required().messages({
      'string.empty': formErrors.REQUIRED
    })
  },
  primaryActivity: {
    value: '',
    label: 'Primary Activity',
    limit: 150,
    input: InputsEnum.INPUT,
    type: TextInputTypes.TEXT,
    joi: joi.string().optional().allow('')
  },
  poolableTipPercentage: {
    value: '',
    label: 'Poolable Tip Percentage',
    input: InputsEnum.MASKED,
    mask: percentageMask,
    required: true,
    clearOnDelete: true,
    joi: joi.string().regex(percentageRegex).required().messages({
      'string.pattern.base': formErrors.INVALID_NUMBER,
      'string.empty': formErrors.REQUIRED
    })
  },
  positions: {
    value: [],
    label: 'Entry Levels',
    input: InputsEnum.MULTI_SELECT,
    endpoint: endpoints.SEARCH_ALL_POSITIONS,
    joi: joi.array().optional()
  },
  siteUrl: {
    value: '',
    label: 'Notion Site URL',
    input: InputsEnum.INPUT,
    joi: joi.string().uri().allow(null).allow('').optional().messages({
      'string.uri': formErrors.INVALID_URL
    })
  },
  alcoholCertification: {
    value: false,
    label: 'Alcohol Certificate Required',
    input: InputsEnum.CHECK,
    joi: joi.boolean().optional()
  },
  uniformRequired: {
    value: false,
    label: 'Uniform Approval Required',
    input: InputsEnum.CHECK,
    joi: joi.boolean().optional()
  }
};
